import "./App.css";
import PageRouting from "./PageRouting";
import { Provider } from "react-redux";
import Store from "./app/Store";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Provider store={Store}>
        <PageRouting />
      </Provider>
    </BrowserRouter>
  );
}

export default App;
